export default {
    TOP_CARDS_REQUEST: 'APP/COMMISSION_MANAGEMENT/TOP_CARDS_REQUEST',
    TOP_CARDS_SUCCESS: 'APP/COMMISSION_MANAGEMENT/TOP_CARDS_SUCCESS',
    TOP_CARDS_ERROR: 'APP/COMMISSION_MANAGEMENT/TOP_CARDS_ERROR',
  };
  